<template>
  <BaseAlert
    v-if="company.activeSubscription?.plan === 'lite' && !completedOnboardingTasks "
    :text="$t('treatwell.lite_plan_not_active.message', brandName())"
    color="warning"
    v-test="'tw-lite-plan-not-active'"
  />
  <BaseAlert
    v-else-if="needsToCompleteKYC && hasActiveVenue"
    :text="$t('admin.treatwell.kyc_warning.text')"
    :primaryAction="$t('admin.treatwell.kyc_warning.action')"
    :secondaryAction="$t('global.learn_more')"
    color="warning"
    @primaryAction="emit('kyc')"
    @secondaryAction="emit('learnMore')"
    v-test="'tw-kyc-warning'"
  />
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { brandName } from '@/helpers/brand-name';
import { useCompanyStore } from '@/stores/company';
import { useTreatwellStore } from '@/stores/treatwell';

// A Lite plan that can't use the marketplace, or payouts blocked until the salon verifies
const emit = defineEmits<{
  kyc: [];
  learnMore: [];
}>();

const { company } = storeToRefs(useCompanyStore());
const { completedOnboardingTasks, needsToCompleteKYC, hasActiveVenue } =
  storeToRefs(useTreatwellStore());
</script>
